module.exports = __webpack_public_path__ + "img/unlink4.67882a32.png";